import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  Link,
  Avatar
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import usePiwik from 'src/hooks/usePiwik'

const tagColors = {
  default: '#2d3e50',
  FWReports: '#893535',
  Plus: '#007e67'
}

const useStyles = makeStyles(() => ({
  clickable: {
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}))

const LiveFeedItem = ({
  title,
  description,
  origin,
  link,
  tags = [],
  isPlus,
  articleId
}) => {
  const { handleTracking, updateCustomVar } = usePiwik()
  const classes = useStyles()

  const handleArticleClick = () => {
    updateCustomVar('article_id', articleId)
    handleTracking('firstword-ai', 'click', 'live-feed')
    window.open(link, '_blank')
  }

  const getOriginLabel = () => {
    if (!origin) return 'FirstWord Pharma'
    if (origin.includes('HealthTech') || origin.includes('MedDev'))
      return 'FirstWord HealthTech'
    return 'FirstWord Pharma'
  }

  const renderTags = () => [
    ...tags.map(tag => (
      <Chip
        key={tag}
        label={tag}
        size="small"
        sx={{
          borderRadius: 0,
          marginRight: 1,
          backgroundColor: tagColors[tag] || tagColors.default,
          color: 'white'
        }}
      />
    )),
    isPlus && (
      <Chip
        key="plus"
        label="+ PLUS"
        size="small"
        sx={{
          borderRadius: 0,
          marginRight: 1,
          backgroundColor: tagColors.Plus,
          color: 'white'
        }}
      />
    )
  ]

  return (
    <Card
      variant="outlined"
      sx={{ marginBottom: 2, cursor: 'pointer' }}
      onClick={handleArticleClick}
    >
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Avatar
              sx={{
                marginRight: 1,
                backgroundColor: isPlus
                  ? tagColors.Plus
                  : tagColors[origin] || tagColors.default
              }}
            >
              FW
            </Avatar>
            <Chip label={getOriginLabel()} size="small" />
          </Box>
          <Box>{renderTags()}</Box>
        </Box>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
            <Link className={classes.clickable}>…read more</Link>
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

LiveFeedItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  origin: PropTypes.string,
  link: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  isPlus: PropTypes.bool,
  articleId: PropTypes.string
}

export default LiveFeedItem
